// Track the *visible* viewport (shrinks when the mobile keyboard opens) as CSS vars.
const update = () => {
  const vv = window.visualViewport;
  if (!vv) return;
  document.documentElement.style.setProperty("--vvh", `${vv.height}px`);
  document.documentElement.style.setProperty("--vvt", `${vv.offsetTop}px`);
  document.documentElement.style.setProperty("--vvw", `${vv.width}px`);
  document.documentElement.style.setProperty("--vvl", `${vv.offsetLeft}px`);
};

if (window.visualViewport) {
  window.visualViewport.addEventListener("resize", update);
  window.visualViewport.addEventListener("scroll", update);
  // Rotation: some Android browsers fire orientation change before the viewport settles.
  window.addEventListener("orientationchange", () => { update(); setTimeout(update, 350); });
  update();
}

export {};
